<template>
  <div class="main-content" @click="closeCalendar">

    <OrderInvoicesBlock/>

    <div class="fixedOrders mt-1" v-if="showOrderedDrugs">
      <OrderedDrugs
        :orderedDrugs="orderedDrugs"
      />
    </div>

    <div class="card">
      <div class="card-body">
        <form @submit.prevent="search(1)" class="fs-12">
          <SearchFilter ref="searchFilter"
                        :page="paginator && paginator.current_page || 1"
                        :lastStoreRev="lastStoreRev"
                        :showOrderedDrugs="(show) => this.showOrderedDrugs = show"
                        :updateDisplaySettings="(s) => displaySettings = s"
                        :search="() => search()"/>

          <div class="flex justify-content-end">
            <LoadingButton
              title="Обновить количество для заказа"
              type="button"
              :loading="btnLoadingParsePrice"
              :color="$constants.PRIMARY_COLOR"
              :onClick="() => collectDrugStoreRequest()"
              className="btn btn-outline-info mr-2"
            />
            <div>
              <div class="input-group pr-3">
                <div class="input-group-prepend">
                  <span class="input-group-text">Ресурс</span>
                </div>
                <select class="form-control" v-model="selectedPriceInfoSupplier">
                  <option v-for="s in priceInfoSuppliers" :key="s.id" :value="s.id">{{ s.title }}</option>
                </select>
                <LoadingButton
                  title="начать сбор цен"
                  type="button"
                  className="btn btn-outline-info"
                  :onClick="() => commencePriceParse()"
                  :loading="btnLoadingParsePrice"
                  :color="$constants.LOADING_COLOR"
                />
              </div>
            </div>
            <vue-ladda button-class="btn btn-info"
                       type="submit"
                       data-style="zoom-in"
                       :loading="loading">Поиск
            </vue-ladda>
          </div>
        </form>
      </div>
    </div>

    <pulse-loader :loading="loading" :color="loadingColor" class="text-center"/>

    <div class="card" v-if="!loading && searchRecordsShow">
      <div class="card-body">
        <template v-if="!records || !records.length">
          <h4>Препаратов не найдено</h4>
        </template>
        <template v-else>
          <div class="flex justify-content-between">
            <div v-if="paginator" class="flex flex_gap_5">
              <paginate
                v-model="paginator.current_page"
                :page-count="paginator.last_page"
                :page-range="10"
                :margin-pages="2"
                :click-handler="(page) => search(page, false, true)"
                :prev-text="'&laquo'"
                :next-text="'&raquo'"
                :container-class="'pagination mb-0'"
                :prev-class="'page-item'"
                :prev-link-class="'page-link'"
                :page-class="'page-item'"
                :page-link-class="'page-link'"
                :next-class="'page-item'"
                :next-link-class="'page-link'"
                :active-class="'active green_btn'">
              </paginate>
              <div class="align-self-center">
                Всего записей: <strong class="fs-18">{{ paginator.total }}</strong>
              </div>
            </div>
            <div>
              <vue-ladda @click="updateRecords()" button-class="btn btn-info"
                         data-style="zoom-in"
                         :loading="saveLoading">Сохранить
              </vue-ladda>
            </div>
          </div>
          <DrugsList
            ref="drugsList"
            :getActiveDrug="(drugData) => this.getActiveDataFromSite(drugData)"
            :drugLinks="drugLinks"
            :drugsTasks="drugsTasks"
            :updatingDrug="updatingDrug"
            :records="records"
            :countrySelected="+$refs.searchFilter?.filter?.type === 4 && +$refs.searchFilter?.filter?.searchData"
            :drugsOrdered="ordered"
            :invoices="invoices"
            :combineInvoices="combineInvoices"
            :freezeInvoices="freezeInvoices"
            :ordersStat="ordersStat"
            :soldData="soldData"
            :displaySettings="displaySettings"
            :storeDrugData="storeDrugData"
            :profitCalculation="{...$refs.searchFilter.profitCalculation, countryId: +$refs.searchFilter.filter.type === 4 ? $refs.searchFilter.filter.searchData : null}"
          />
          <hr>
          <div class="flex justify-content-between">
            <div v-if="paginator">
              <paginate
                v-model="paginator.current_page"
                :page-count="paginator.last_page"
                :page-range="10"
                :margin-pages="2"
                :click-handler="(page) => search(page, false, true)"
                :prev-text="'&laquo'"
                :next-text="'&raquo'"
                :container-class="'pagination'"
                :prev-class="'page-item'"
                :prev-link-class="'page-link'"
                :page-class="'page-item'"
                :page-link-class="'page-link'"
                :next-class="'page-item'"
                :next-link-class="'page-link'"
                :active-class="'active green_btn'">
              </paginate>
            </div>
            <div>
              <vue-ladda @click="updateRecords()" button-class="btn btn-info"
                         data-style="zoom-in"
                         :loading="saveLoading">Сохранить
              </vue-ladda>
            </div>
          </div>

        </template>
      </div>
    </div>

  </div>
</template>

<script>

import api from '@/api'
import SearchFilter from './components/Filter'
import SearchResult from "./components/SearchResult";
import VueLadda from 'vue-ladda/src/vue-ladda.vue';
import Paginate from 'vuejs-paginate';
import DrugsList from './components/DrugsList'
import OrderInvoicesBlock from "@/views/nomenclature/components/OrderInvoicesBlock";
import OrderedDrugs from "@/views/nomenclature/components/OrderedDrugs";
import LoadingButton from "@/components/buttons/LoadingButton";
import {customUpdateData} from "@/eventsBus";

import {nextTick} from 'vue';
import store from "@/store";

export default {
  title: 'Синхронизация',
  components: {
    OrderedDrugs,
    SearchFilter,
    SearchResult,
    VueLadda,
    DrugsList,
    Paginate,
    OrderInvoicesBlock,
    LoadingButton,
  },
  data() {
    return {
      displaySettings: {},
      drugLinks: {},
      priceInfoSuppliers: [
        {id: 14, title: 'uteka'}
      ],
      selectedPriceInfoSupplier: 0,
      showOrderedDrugs: false,
      btnLoadingParsePrice: false,
      loadingColor: this.$constants.LOADING_COLOR,
      loading: false,
      updatingDrug: null,
      saveLoading: false,
      records: null,
      freezeInvoices: {},
      invoices: {},
      combineInvoices: {},
      paginator: null,
      searchRecordsShow: false,
      extraData: {},
      monthIndex: {},
      drugsTasks: {},
      ordersStat: {},
      lastStoreRev: null,
      soldData: {},
      storeDrugData: {},
      ordered: {},
      orderedDrugs: null,
    }
  },
  created() {
    this.selectedPriceInfoSupplier = this.priceInfoSuppliers[0].id;
    customUpdateData.$on(
      "editDrug",
      async (data = {}) => {
        this.updatingDrug = data.drugId;
        await this.search((this.paginator.current_page ?? 1), true);
        this.updatingDrug = null;
      });
  },
  computed: {
    $AllProjects() {
      const stores = this.$store.getters['platform/projects'].filter((s) => s.id !== 4)
      return _.orderBy(stores, 'id');
    },
  },
  methods: {
    async collectDrugStoreRequest() {
      this.btnLoadingParsePrice = true;
      const {data} = await api.post('/tasks/new', {
        type: 'updateStoreDrugRequest'
      });
      if (data.success) {
        toastr['success'](data.message || 'Сохранено', 'Успешно')
      } else {
        toastr['error'](data.message || 'Ошибка сервера')
      }
      this.btnLoadingParsePrice = false;
    },
    async getActiveDataFromSite(drugData) {
      if (!this.drugLinks[drugData.projectId]) this.drugLinks[drugData.projectId] = {};
      if (!this.drugLinks[drugData.projectId][drugData.drugId]) {
        this.drugLinks[drugData.projectId][drugData.drugId] = {
          success: false,
          link: null,
          loading: false
        };
        this.drugLinks = {...this.drugLinks};
      }
      this.drugLinks[drugData.projectId][drugData.drugId].loading = true;
      const {data} = await api.post('/new/drugs/infoType', {
        types: ['projectInfo'],
        drug_id: drugData.drugId,
        project_id: drugData.projectId
      })
      this.drugLinks[drugData.projectId][drugData.drugId].success = data.success;
      this.drugLinks[drugData.projectId][drugData.drugId].link = data.link_share ?? data.link;
      this.drugLinks[drugData.projectId][drugData.drugId].message = data.message;

      this.drugLinks[drugData.projectId][drugData.drugId].loading = false;
      this.drugLinks = {...this.drugLinks}
    },
    getFilterValue(key, field = null) {
      return field ? this.$refs.searchFilter[field] : this.$refs.searchFilter.filter[key];
    },
    async updateRecords(page = null) {
      // const updateData = this.$refs.searchResult.updateData;
      const updateData = this.$refs.drugsList.toUpdate;
      if (!Object.keys(updateData).length) return;
      this.saveLoading = true;
      let {data} = await api.post('/nomenclature/updatedrugs', {updateData});
      if (!data.success) {
        toastr['error'](data.message || 'Синхронизация не выполнена', 'Ошибка')
      } else {
        this.$refs.drugsList.toUpdate = {};
        toastr['success'](data.message || 'Сохранено', 'Успешно')
        await this.search(page);
      }
      this.saveLoading = false;
    },
    async commencePriceParse() {
      this.btnLoadingParsePrice = true;
      const {data} = await api.post('/new/suppliers/scan', {
        supplier_id: this.selectedPriceInfoSupplier
      })
      if (data.success) {
        toastr['success'](data.message || 'парсинг запущен', 'Успешно')
      } else {
        toastr['error'](data.message || 'ошибка сервер', 'Неуспешно')
      }
      this.btnLoadingParsePrice = false;
    },
    async search(p = null, silent = false, ackRequest = false) {
      // this.$refs.searchResult.updateData = {};
      const updateData = this.$refs.drugsList?.toUpdate ?? {};
      if (ackRequest && Object.keys(updateData).length) {
        store.dispatch("platform/setGlobalModalData", {
          responseData: {p, silent},
          headerText: 'Желаете перейти на новую страницу?',
          messageText: '<h4>Все изменения на странице могут быть утеряны, сохранить изменения?</h4>',
          extraBtnText: 'перейти без сохранения',
          acceptBtnText: 'сохранить и перейти',
          accept: async (m) => {
            store.dispatch("platform/setGlobalModalData", null);
            await this.updateRecords(p);
          },
          reject: (m) => {
            store.dispatch("platform/setGlobalModalData", null);
            this.search(p, silent);
          }
        });
        return;
      }
      let page
      if (p) {
        page = p
      } else {
        page = this.paginator && this.paginator.current_page || 1;
      }
      // this.$refs.searchFilter.updateUrl();
      if (!silent) {
        this.records = null;
        this.loading = true;
        this.paginator = null;
      } else {
        this.saveLoading = true;
      }
      this.searchRecordsShow = true;
      this.$refs.searchFilter.updateFilter(page);
      let {data: r_data} = await api.post('/nomenclature/synchronize', {
        page: page,
        filter: this.$refs.searchFilter.filter,
        extraSearchOptions: this.$refs.searchFilter.extraSearchOptions
      })
      if (r_data.success) {
        const {data, ...pagination} = r_data.records;
        this.paginator = pagination;
        // this.extraData = r_data.extraData;
        // this.monthIndex = r_data.monthIndex;
        this.ordered = r_data.ordered.reduce((acc, o) => {
          if (!acc[o.drug_id]) acc[o.drug_id] = [];
          acc[o.drug_id].push(o)
          return acc;
        }, {})
        this.drugsTasks = r_data.tasks.reduce((acc, t) => {
          if (!acc[t.drug_id]) acc[t.drug_id] = [];
          acc[t.drug_id].push(t);
          return acc;
        }, {})
        this.invoices = r_data.invoices;
        this.storeDrugData = Object.keys(r_data.storeDrugData).reduce((acc, k) => {
          if (k) {
            acc[k] = r_data.storeDrugData[k];
          }
          return acc;
        }, {});
        this.combineInvoices = r_data.combineInvoices;
        this.ordersStat = r_data.ordersStat;
        this.soldData = data.reduce((acc, r) => {
          acc[r.id] = {...(r_data.soldData[r.id] ?? {}), options: {showStoreTrend: false}};
          return acc;
        }, {});
        //   Object.keys(r_data.soldData).reduce((acc, id) => {
        //   acc[id] = {...r_data.soldData[id], options: {showStoreTrend: false}};
        //   return acc;
        // }, {});
        this.freezeInvoices = r_data.freezeInvoices;
        this.orderedInvoices = r_data.orderedInvoices;
        // this.records = null;
        // await nextTick();
        Object.keys(this.freezeInvoices).forEach((dId) => {
          if (!this.storeDrugData[dId]) this.storeDrugData[dId] = {total: 0};
          this.storeDrugData[dId].total = (this.storeDrugData[dId]?.total ?? 0) + this.freezeInvoices[dId].total_qty;
          const invoice = (this.invoices[dId] ?? []).find((i) => i.status === 0 && i.type === 1);
          this.freezeInvoices[dId].current_cost_price = Math.round((invoice?.cost_price ?? 0) * 100) / 100 ?? 0;
          this.freezeInvoices[dId].cost_diff = Math.round((this.freezeInvoices[dId].cost_price - this.freezeInvoices[dId].current_cost_price) * 10) / 10
        });

        this.lastStoreRev = r_data.last_store_rev ?? null;
        this.records = data.reduce((acc, r) => {
          r.prices = r.prices.reduce((ac, p) => {
            ac.push({...p, price: p.price * r.pack_set})
            return ac
          }, [])
          r.details.forEach((d, i) => {
            if (d.group_alias === 'egk' && d.alias === 'id') {
              const egk = r_data.egkCodes.find((c) => c.id === d.int_value);
              if (egk) {
                r.details[i].invalid = egk.invalid;
              }
            }
          })
          if (!r.options) r.options = {};
          acc.push(r)
          return acc
        }, []);
      }
      this.loading = false;
      this.saveLoading = false;
    },
    closeCalendar(e) {
      if (e.target.classList.contains('calendarAction') || e.target.classList.contains('prev') || e.target.classList.contains('next')) return;
      if (this.$refs.searchFilter && this.$refs.searchFilter.$refs.searchValue) {
        this.$refs.searchFilter.$refs.searchValue.calendarOpen = false;
      }
      if (this.$refs.searchFilter && this.$refs.searchFilter.$refs.calendar) {
        this.$refs.searchFilter.$refs.calendar.showDayView = false;
      }
    },
  },
}

</script>

<style scoped>
.fixedOrders {
  position: fixed;
  z-index: 9990;
  top: 0;
  left: 40%;
  height: 50px;
  overflow: auto;
}

.fs-12 {
  font-size: 12px;
}
</style>
